import { useThemeToggle } from '../hooks/useThemeToggle'

export default function ThemeToggle() {
  const { theme, toggle } = useThemeToggle()
  const mode = theme === 'dark' ? 'night' : 'day'

  return (
    <button
      className="toggle"
      data-mode={mode}
      role="switch"
      aria-checked={mode === 'night'}
      aria-label="Switch between day and night display"
      title="Toggle day / night"
      onClick={toggle}
    >
      <svg className="ic-sun" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} aria-hidden="true">
        <circle cx="12" cy="12" r="4.4" />
        <path d="M12 2v2.6M12 19.4V22M2 12h2.6M19.4 12H22M4.9 4.9l1.8 1.8M17.3 17.3l1.8 1.8M19.1 4.9l-1.8 1.8M6.7 17.3l-1.8 1.8" />
      </svg>
      <svg className="ic-moon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M20 14.5A8.2 8.2 0 0 1 9.5 4a8.3 8.3 0 1 0 10.5 10.5z" />
      </svg>
    </button>
  )
}
